"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var determineEnv = function () {
    switch (window.location.hostname) {
        case 'localhost':
            return 'local';
        case 'opositando.shop':
            return 'production';
        default:
            return 'development';
    }
};
exports.default = determineEnv;
//# sourceMappingURL=determineEnv.js.map